import { render, staticRenderFns } from "./ObjectType.vue?vue&type=template&id=0af42790&scoped=true&"
import script from "./ObjectType.vue?vue&type=script&lang=js&"
export * from "./ObjectType.vue?vue&type=script&lang=js&"
import style0 from "./ObjectType.vue?vue&type=style&index=0&id=0af42790&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af42790",
  null
  
)

export default component.exports